import { IDealSourceData, ILenderVehicle, IRACVehicle, IVehiclePayload } from '../types';
import { HYPHEN } from '../constants';

const fieldsToHide = {
  age: null,
  third_row_seat: null,
  unit_cost: null,
  drive_type: HYPHEN,
  color: null,
  color_canonical: null,
  guidebook: HYPHEN,
  stock: HYPHEN,
  location: HYPHEN,
};

export const useHideRACVehicleField = (
  vehicles?: IRACVehicle[],
  dealSourceVehicleId?: number | undefined,
): IRACVehicle[] | undefined => {
  if (!vehicles) return vehicles;

  return vehicles.map((vehicle) => ({
    ...vehicle,
    ...(vehicle.manually_created && { ...fieldsToHide }),
    ltv_value: {
      ...vehicle.ltv_value,
      ...(vehicle.manually_created && { profit: null }),
      ...(vehicle.id === dealSourceVehicleId && { extra_down_payment: null }),
    },
  }));
};

export const useHideLenderVehicleField = (
  vehicles?: ILenderVehicle[],
  dealSourceData?: IDealSourceData,
): ILenderVehicle[] | undefined => {
  if (!vehicles) return vehicles;

  return vehicles.map((vehicle) => ({
    ...vehicle,
    ...(vehicle.manually_created && {
      ...fieldsToHide,
      profit: null,
    }),
    ...(vehicle.id === dealSourceData?.vehicle_id && { salesperson_bucket: null }),
    ...(vehicle.id === dealSourceData?.vehicle_id &&
      !dealSourceData?.sale_vehicle?.book_value && { guidebook_value: null }),
  }));
};

export const useHideVehicleField = (vehicles?: IVehiclePayload[]): IVehiclePayload[] | undefined => {
  if (!vehicles) return vehicles;

  return vehicles.map((vehicle) => {
    if (vehicle.manually_created) {
      return { ...vehicle, ...fieldsToHide, dealer_profit: null, dealer: { ...vehicle.dealer, shortname: HYPHEN } };
    }

    return vehicle;
  });
};
